import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getSequenceNumbers({
    date = null,
    interval = null,
    endDate = null,
  }) {
    return axiosIns.get(
      '/waiter/receipt_sequences',
      {
        params: snakecaseKeys({
          date,
          interval,
          endDate,
        }),
      },
    )
  },
}
